import getWindow from 'utils/get-window'

const captureException = (error) => {
  getWindow().Sentry && getWindow().Sentry.captureException(error)
}

export default captureException
